class RemissionService {
    constructor($q, $http, ngAuthSettings) {
        this.$q = $q;
        this.$http = $http;
        this.ngAuthSettings = ngAuthSettings;
    }

    getBranchesByThirdId(thirdId) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri + '/user/third-center-operating?thirdId=' + thirdId,
                cache: false
            }).then(function (response) {
                resolve(response.data);
            }, function (reason) {
                reject(reason);
            });
        });
    }

    getRemissionState(documentNumber, remissionNumber, limit, page) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri2 + this.ngAuthSettings.config.paths.REPORTS.SYNC.REMISSION.LIST +
                    '?terceroId=' + documentNumber +
                    '&remisionId=' + remissionNumber +
                    '&limit=' + limit +
                    '&page=' + page,
                cache: false
            }).then(function (response) {
                resolve(response.data);
            }, function (reason) {
                reject(reason);
            });
        });
    }

    getRemissionStates(documentNumber, branchCode, limit, page) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri2 + this.ngAuthSettings.config.paths.REPORTS.SYNC.REMISSION.LIST +
                    '?terceroId=' + documentNumber +
                    '&sucursalCodigo=' + branchCode+
                    '&limit=' + limit +
                    '&page=' + page,
                cache: false
            }).then(function (response) {
                resolve(response.data);
            }, function (reason) {
                reject(reason);
            });
        });
    }

    getRemissionStatesBranches(documentNumber, branchCodes, fecha_ini, fecha_fin, limit, page) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri2 + this.ngAuthSettings.config.paths.REPORTS.SYNC.REMISSION.LIST2,
                data: {
                    'documentoTercero': documentNumber,
                    'branchCode': branchCodes,
                    'fecha_ini': fecha_ini,
                    'fecha_fin': fecha_fin,
                    'limit': limit,
                    'page': page
                },
                cache: false
            }).then(function (response) {
                resolve(response.data);
            }, function (reason) {
                reject(reason);
            });
        });
    }

    getExportExcel(remissions,nameClient){
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri2 + this.ngAuthSettings.config.paths.REPORTS.SYNC.REMISSION.EXPORTEXCEL,
                data : {
                    'remissions' : remissions,
                    'nameClient' : nameClient
                },
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                cache : false
            }).then(function (response) {
                resolve(response.data);
            }, function (reason) {
                reject(reason);
            });
        });
    }
}

RemissionService.$inject = ['$q', '$http', 'ngAuthSettings'];

export default RemissionService;



/** WEBPACK FOOTER **
 ** ./www/components/reports/remission/remission.service.js
 **/